type CollapsedValue = {
  [key: string]: string;
};

type NavBarStateReturnType = {
  shouldCollapse: boolean;
  overrideOldValue: boolean;
};

export const getNavBarStateWIthFallback = (
  subscriptionId: string,
  collapsedValue?: CollapsedValue | boolean | string
): NavBarStateReturnType => {
  const fallbackValue = { shouldCollapse: false, overrideOldValue: true };

  if (collapsedValue === undefined || collapsedValue === null) {
    return { shouldCollapse: false, overrideOldValue: false };
  }

  if (
    typeof collapsedValue === 'string' &&
    ['true', 'false'].includes(collapsedValue.toLowerCase())
  ) {
    return { shouldCollapse: collapsedValue === 'true', overrideOldValue: true };
  }

  if (typeof collapsedValue === 'boolean') {
    return { shouldCollapse: collapsedValue, overrideOldValue: true };
  }

  try {
    const collapsed = JSON.parse(collapsedValue as string);

    return { shouldCollapse: collapsed?.[subscriptionId], overrideOldValue: false };
  } catch {
    return fallbackValue;
  }
};
